import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function RadioIcon({ size, color, checked }: { size: number; color: DripsyColor; checked: boolean }) {
  const finalColor = useDripsyColor({ color });
  return checked ? (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={finalColor}>
      <Path d="M0 0h24v24H0V0z" fill="none" />
      <Path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
      <Circle cx="12" cy="12" r="5" />
    </Svg>
  ) : (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={finalColor}>
      <Path d="M0 0h24v24H0V0z" fill="none" />
      <Path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
    </Svg>
  );
}
export default RadioIcon;
